
import OnboardlistCategory from './OnboardlistCategory'
import OnbordingList from './OnbordingList'
import QuestionCategory from './QuestionCategory'
import QuestionChapters from './QuestionChapters'
import Questions from './Questions'
import AwardListing from './AwardListing'
const routes = [
  {
    type: 'collapse',
    key: 'OnboardlistCategory',
    route: '/',
    component: <AwardListing />,
  },
  {
    type: 'collapse',
    key: 'home',
    route: '/:page_id/:type',
    component: <QuestionCategory />,
  },
  {
    type: 'collapse',
    key: 'home',
    route: '/:page_id/:chapter_id/:type',
    component: <QuestionChapters />,
  },

]

export default routes
